/* eslint-disable */
// @ts-nocheck
import { reducerWrapper } from '../../support/utils';
import { LOADING_STATUS } from '../../support/constants';
import { CREATE_BRANCH_CUSTOM_EXPORT, RETRIEVE_BRANCH_CUSTOM_EXPORTS } from '../../actions/BranchCustomExportActions';
import type { CustomExportReducer } from '../../types/customExportTypes';
import { processExportInfo } from './customExportReducerUtils';
export const INIT_STATE: CustomExportReducer = {
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  exports: [],
};

function Handler(state: CustomExportReducer = INIT_STATE, action) {
  switch (action.type) {
    case CREATE_BRANCH_CUSTOM_EXPORT.response:
    case RETRIEVE_BRANCH_CUSTOM_EXPORTS.response:
      return !action.data || !action.data.length
        ? { ...state, loadingStatus: LOADING_STATUS.LOADED }
        : { ...state, loadingStatus: LOADING_STATUS.LOADED, exports: processExportInfo(action.data) };

    default:
      return state;
  }
}

const BranchCustomExport = reducerWrapper(INIT_STATE, Handler, {
  request: [CREATE_BRANCH_CUSTOM_EXPORT, RETRIEVE_BRANCH_CUSTOM_EXPORTS],
  error: [CREATE_BRANCH_CUSTOM_EXPORT, RETRIEVE_BRANCH_CUSTOM_EXPORTS],
});
export default BranchCustomExport;
